<div class="container">
  <div class="sidebar">
    <div class="sidebar__header">
      <app-my-account-user
        [name]="userName()"
        [avatar]="userAvatar()"
      />
    </div>

    <div class="sidebar__vertical-tabs">
      <app-vertical-tabs name="Personal" [tabs]="MY_ACCOUNT_PERSONAL_TABS" />
      <app-vertical-tabs name="General" [tabs]="MY_ACCOUNT_GENERAL_TABS" />
    </div>
  </div>

  <div class="content">
    <router-outlet />
  </div>
</div>
